import { render, staticRenderFns } from "./onboarding-questionnaire.vue?vue&type=template&id=5c0f5680&"
import script from "./onboarding-questionnaire.vue?vue&type=script&lang=js&"
export * from "./onboarding-questionnaire.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-questionnaire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports